import { uploadedFileClient } from "../clients/uploadedFileClient"
import type {
  UploadedFileDto,
  DeleteUploadedFileResponseDto,
} from "../types/uploadedFile.types"

/**
 * Uploaded File Service
 * Business logic layer - handles API responses, errors, and side effects
 */
export const uploadedFileService = {
  /**
   * Upload a file to S3
   */
  uploadFile: async (file: File): Promise<UploadedFileDto> => {
    try {
      const uploadedFile = await uploadedFileClient.uploadFile(file)
      return uploadedFile
    } catch (error: any) {
      throw error
    }
  },

  /**
   * Get uploaded file metadata by ID
   */
  getUploadedFile: async (id: string): Promise<UploadedFileDto> => {
    try {
      const file = await uploadedFileClient.getUploadedFile(id)
      return file
    } catch (error: any) {
      throw error
    }
  },

  /**
   * Delete uploaded file
   */
  deleteUploadedFile: async (
    id: string
  ): Promise<DeleteUploadedFileResponseDto> => {
    try {
      const response = await uploadedFileClient.deleteUploadedFile(id)
      return response
    } catch (error: any) {
      throw error
    }
  },
}

export default uploadedFileService

